import { Component, OnInit, ViewChild, ElementRef, NgZone, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { PetsService } from '../../../../_services';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { Router } from '@angular/router';

import { AuthenticationService, OwnerService } from '../../../../_services';
import { AuthService , FacebookLoginProvider, GoogleLoginProvider} from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
import { DatePipe } from '@angular/common';
import { AppComponent } from '../../../../app.component';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter } from '@angular/material';
import * as moment from 'moment';
import { environment } from '../../../../../environments/environment';
import * as $ from 'jquery'
import { zipAll } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner"; 
import data from '../../../../animals.json';
import { TranslateService } from '@ngx-translate/core';
interface Animals {
  title: string;
  author: string;
}

@Component({
  selector: 'app-lostpetinfo',
  templateUrl: './petinfo.component.html',
  styleUrls: ['./petinfo.component.scss']
})

export class LostPetinfoComponent implements OnInit {

  registerForm: FormGroup;
  showFoundSuggestion: boolean = true;
  isChipIdToShowInDetail: boolean = false;
  @Input() showPersonalInfo;
  @Input() minsidePetInfo: any;
  public lat: number;
  public lng: number;
  public zoom: number;
  private geoCoder;
  public Area: any;
  private user: SocialUser;
  private loggedIn: boolean;
  minDate: Date;
  maxDate: Date;
  formattedminDate: any;
  formattedmaxDate: any;
  isChipSelected: '0';
  years = Array();
  days = Array()
  months = Array();
  hours = Array();
  times = Array();
  Animals: Animals[] = data;

  lostMaxDate: Date;
  chipFound: string = "";
  petImgUrl: string = null
  petImagePath = environment.MinsideBaseURL;
  @ViewChild('search') searchElementRef: ElementRef;
  @ViewChild("imgctrl") imgctrl: ElementRef;
  public googleMapstyles: any = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }]

  constructor(
    private dateAdapter: DateAdapter<Date>,
    public app: AppComponent,
    private pets: PetsService,
    private formbuilder: FormBuilder,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private authService: AuthService,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private SpinnerService: NgxSpinnerService,
    private translate: TranslateService
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    // const currentYear = new Date().getFullYear();
    // const currentDate = new Date().getDate();

    this.minDate = new Date(moment().subtract(20, 'years').format());
    var dateChangedvalue = new Date();
    this.maxDate = dateChangedvalue;
    this.lostMaxDate = dateChangedvalue;
  }

  country: any;
  MasterSpecies: any;
  MasterBreeds: any;
  submitted = false;
  IsChipped = false;
  currentUser: any;
  fileData: File = null;
  croppedFileData: any = null;
  previewUrl: any = "assets/img/add-plus-icn.svg";
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  imageError = "";
  ageError = "";
  closeResult = "";
  isMinsideUser: boolean = false;
  FBUserid = "";
  shortToken = "";
  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    sublocality_level_1: 'long_name',
    sublocality_level_2: 'long_name',
    administrative_area_level_1: 'long_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name',
    postal_town: 'long_name'

  };
  ShowFacebookShare:boolean;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  bindTimeFormat() {
    for (var i = 1; i <= 31; i++) {
      this.days.push({ 'text': i, 'value': i });
    }

    this.months = [{ text: "Jan", value: 1, isSelected: false },
    { text: "Feb", value: 2, isSelected: false },
    { text: "Mar", value: 3, isSelected: false },
    { text: "Apr", value: 4, isSelected: false },
    { text: "May", value: 5, isSelected: false },
    { text: "Jun", value: 6, isSelected: false },
    { text: "Jul", value: 7, isSelected: false },
    { text: "Aug", value: 8, isSelected: false },
    { text: "Sep", value: 9, isSelected: false },
    { text: "Oct", value: 10, isSelected: false },
    { text: "Nov", value: 11, isSelected: false },
    { text: "Dec", value: 12, isSelected: false }];

    for (var i = 1900; i <= 2100; i++) {
      this.years.push({ 'text': i, 'value': i, isSelected: false });
    }

    for (var i = 1; i <= 24; i++) {
      this.hours.push({ 'text': i, 'value': i, isSelected: false });
    }

    for (var i = 0; i <= 60; i++) {
      this.times.push({ 'text': i, 'value': i, isSelected: false });
    }
  }

  fileChangeEvent(event: any): void {

  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  open(content) {
    this.previewUrl = "assets/img/add-plus-icn.svg";
    this.croppedFileData = "";
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.previewUrl = this.croppedImage;
      this.croppedFileData = this.croppedImage;
      //return false;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.registerForm.controls['Image'].patchValue("");
      //return false;
    });
    return false;
  }
  private getDismissReason(reason: any): string {
    this.registerForm.controls['Image'].patchValue("");
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  UpdateDobMaxDate() {
    this.lostMaxDate = new Date(moment(this.registerForm.controls["LostFoundDate"].value).subtract(1, 'days').format());
  }

  UpdateLostFoundMaxDate() {
    this.minDate = new Date(moment(this.registerForm.controls["DateOfBirth"].value).add(1, 'days').format());
  }
  ngOnInit() {
    this.ShowFacebookShare = false;
    var CETDATE = new Date(new Date().toLocaleString("en-Us", { timeZone: "Europe/Berlin" }));
    let cetMonth = (CETDATE.getMonth() >= 9 ? CETDATE.getMonth() + 1 : '0' + (CETDATE.getMonth() + 1));
    let cetdate = (CETDATE.getDate() <= 9 ? '0' + CETDATE.getDate() : CETDATE.getDate());
    let cetHours = (CETDATE.getHours() <= 9 ? '0' + CETDATE.getHours() : CETDATE.getHours());
    let cetminute = (CETDATE.getMinutes() < 9 ? '0' + CETDATE.getMinutes() : CETDATE.getMinutes());
    let formattedCurrentDate = CETDATE.getFullYear() + '-' + cetMonth + '-' + cetdate + 'T' + cetHours + ':' + cetminute;
    this.formattedminDate = this.minDate.toISOString().slice(0, 16);
    debugger;
    this.formattedmaxDate = this.maxDate.toISOString().slice(0, 16);
    this.registerForm = this.formbuilder.group({
      IsChipped: ['0'],
      ChipID: [''],
      PetName: ['', [Validators.required, this.noWhitespaceValidator]],
      Age: [''],
      MasterSpeciesID: ['', Validators.required],
      MasterBreedID: [''], //, Validators.required
      LostFoundDate: [formattedCurrentDate, Validators.required],
      DateOfBirth: [''],
      Color: [''],
      IdentificationMark: [''],
      Gender: [0],
      HairType: [0],
      Area: ['', Validators.required],
      State: ['', [Validators.required, this.noWhitespaceValidator]],
      Commune: ['', [this.noWhitespaceValidator]],
      District: ['', [this.noWhitespaceValidator]],
      City: ['', [Validators.required, this.noWhitespaceValidator]],
      Country: ['Norway', Validators.required],
      ZipCode: ['', Validators.required],
      AdditionalInfo: [''],
      ImagePath: [''],
      Company: [''],
      Image: [''],
      croppedFileData: [''],
      lat: [''],
      lng: [''],
      OperationTypeID: [''],
      IsChipIDinDetail: ['0'],
      ShareONFacebook: [''],
      FacebookUserId: [''],
      ShortLivedToken:['']
    });
    this.showPersonalInfo = false;
    this.registerForm.value.IsChipped = 0;
    this.pets.getCountry().subscribe(res => {
      this.country = res;
    });
    this.pets.getSpecies().subscribe(species => {
      this.MasterSpecies = species;

    });
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser.Provider == 'MINSIDE') {
      this.isMinsideUser = true;
      this.registerForm.controls['LostFoundDate'].patchValue('');
    }
    else {
      //load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        this.setCurrentLocation();
        this.geoCoder = new google.maps.Geocoder;
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: []
        });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            //get the place result
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();

            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
            this.fillAddress(place)
            //set latitude, longitude and zoom
            this.lat = place.geometry.location.lat();
            this.lng = place.geometry.location.lng();
            this.zoom = 15;
            this.getSuggestion();
          });
        });
      });
    }

    if (this.minsidePetInfo) {
      var genderValue = 0;
      var hairtypeValue = 0;
      console.log(this.minsidePetInfo);
      var obj = this.minsidePetInfo;
      var dob = null;
      if (obj.BirthYear && obj.BirthMonth && obj.BirthDate) {
        dob = new Date(obj.BirthYear, obj.BirthMonth, obj.BirthDate);
      }
      this.registerForm.controls['IsChipped'].patchValue('1');
      this.registerForm.controls['ChipID'].patchValue(obj.ChipId);

      if (obj.ChipId) {
        this.registerForm.controls['IsChipped'].patchValue('1');
        this.registerForm.controls['ChipID'].patchValue(obj.ChipId);
        this.registerForm.controls['ChipID'].disable();
      }
      this.registerForm.controls['PetName'].patchValue(obj.PetName);
      let currentDate = new Date();
      let age = '';
      if (dob != '' && dob != undefined) {
        var diff = Math.abs(currentDate.getTime() - new Date(dob.getFullYear(), dob.getMonth(), dob.getDate()).getTime());
        var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        age = Math.round(diffDays / 365).toString();
      }

      this.registerForm.controls['Age'].patchValue(age);
      // debugger;
      this.registerForm.controls['Company'].patchValue(this.currentUser.Company)
      if (obj.PetName) {
        this.registerForm.controls['PetName'].disable();
      }

      obj.SpeciesId = obj.SpeciesId == 1 || obj.SpeciesId == 2 ? obj.SpeciesId : 10;
      if (obj.SpeciesId >= 0) {
        this.registerForm.controls['MasterSpeciesID'].patchValue(obj.SpeciesId);
        this.registerForm.controls['MasterSpeciesID'].disable();
      }

      this.registerForm.controls['DateOfBirth'].patchValue(dob);
      this.registerForm.controls['Color'].patchValue(obj.Color);
      if (obj.Color) {
        this.registerForm.controls['Color'].disable();
      }
      this.registerForm.controls['IdentificationMark'].patchValue(obj.IdentificationMark);
      if (obj.IdentificationMark) {
        this.registerForm.controls['IdentificationMark'].disable();
      }

      if (obj.Gender) {
        if (obj.Gender.toLowerCase() == "male") {
          genderValue = 1;
        } else if (obj.Gender.toLowerCase() == "female") {
          genderValue = 2;
        }
      }

      if (obj.Image !== '') {
        this.previewUrl = this.petImagePath + obj.Image;
        this.petImgUrl = this.petImagePath + obj.Image;
      }
      this.registerForm.controls['Gender'].patchValue(genderValue);
      if (obj.HairType) {
        if (obj.HairType.toLowerCase() == 'longhair') {
          hairtypeValue = 1;
        }
        else if (obj.HairType.toLowerCase() == 'sorthair') {
          hairtypeValue = 2;
        }
      }
      this.registerForm.controls['HairType'].patchValue(hairtypeValue);
      this.pets.getBreeds(obj.SpeciesId).subscribe(breeds => {
        this.MasterBreeds = breeds;
        this.registerForm.controls['MasterBreedID'].patchValue(obj.BreedId);
        let data = this.MasterBreeds.find(ob => ob.Value === obj.BreedId);

        if (data) {
          this.registerForm.controls['MasterBreedID'].disable();
        } else {
          if (obj.BreedName) {
            let data1 = this.MasterBreeds.find(ob => ob.Text.toLowerCase() === obj.BreedName.toLowerCase());
            if (data1) {
              obj.BreedId = data1.Value; // in case id does not match patch with Name
              this.registerForm.controls['MasterBreedID'].disable();
            }
          }
        }
        this.registerForm.controls['MasterBreedID'].patchValue(obj.BreedId);
        this.getSuggestion();
      });
    }

    this.pets.checkFacebookAccount(this.currentUser.ID).subscribe(Response => {
     
      if (Response) {
        this.ShowFacebookShare = true;
      }
    });
  }

  get petf() {
    return this.registerForm.controls;
  }

  OnClick() {

  }

  getSuggestion() {
    this.chipFound = "";

    if (this.minsidePetInfo) {   // In case you Minside Pet
      let filters = {
        "SearchFilters": {
          "SpeciesID": this.registerForm.getRawValue().MasterSpeciesID,
          "BreedID": this.registerForm.getRawValue().MasterBreedID,
          "lat": this.lat,
          "lng": this.lng,
          "radiousDistance": 20,
          "OperationTypeID": 2
        }
      }
      this.onPosted.emit(filters)
    } else {
      let filters = {
        "SearchFilters": {
          "SpeciesID": this.registerForm.value.MasterSpeciesID,
          "BreedID": this.registerForm.value.MasterBreedID,
          "lat": this.lat,
          "lng": this.lng,
          "radiousDistance": 10,
          "OperationTypeID": 2
        }
      }
      this.onPosted.emit(filters)
    }
  }

  getChipInfo() {
    this.registerForm.controls['PetName'].patchValue("");
    // this.registerForm.controls['PetAge'].patchValue(""); 
    this.registerForm.controls['MasterSpeciesID'].patchValue("");
    this.registerForm.controls['Color'].patchValue("");
    this.registerForm.controls['IdentificationMark'].patchValue("");
    this.registerForm.controls['MasterBreedID'].patchValue("");

    // this.pets.IsChipIDExists(this.registerForm.value.ChipID, this.registerForm.value.OperationTypeID).subscribe(IsChipExist =>{
    this.pets.IsChipIDExists(this.registerForm.value.ChipID, 1).subscribe(IsChipExist => {
      if (IsChipExist == true && this.registerForm.value.ChipID.trim() != "") {
        // this.chipFound = "Pet with ChipID " + this.registerForm.value.ChipID + " Already exists";
        this.chipFound = "Kjæledyr med ChipID " + this.registerForm.value.ChipID + " Eksisterer allerede";
        this.registerForm.controls['ChipID'].patchValue("");
      }
      else {
        this.pets.getChipInfo(this.registerForm.value.ChipID).subscribe(chipInfo => {
          var genderValue: any;
          var hairtypeValue: any;
          if (!chipInfo.IsAlive)// data from api came true as false and false as true.
          {
            if (chipInfo.ChipId) {
              var dob = null;
              let currentDate = new Date();
              if (chipInfo.BirthYear && chipInfo.BirthMonth && chipInfo.BirthDate) {
                dob = new Date(chipInfo.BirthYear, chipInfo.BirthMonth, chipInfo.BirthDate);
              }
              //PetPhoto
              if (chipInfo.PetPhoto !== '') {
                this.previewUrl = chipInfo.PetPhoto;
              }
              this.petImgUrl = chipInfo.PetPhoto;
              this.registerForm.controls['PetName'].patchValue(chipInfo.PetName);

              let age = '';
              if (dob != '' && dob != undefined) {
                var diff = Math.abs(currentDate.getTime() - new Date(chipInfo.BirthYear, chipInfo.BirthMonth, chipInfo.BirthDate).getTime());
                var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
                age = Math.round(diffDays / 365).toString();
              }

              this.registerForm.controls['Age'].patchValue(age);
              if (chipInfo.SpeciesID === 1 || chipInfo.SpeciesID == 2) {
                this.registerForm.controls['MasterSpeciesID'].patchValue(chipInfo.SpeciesID);
              }
              else {
                this.registerForm.controls['MasterSpeciesID'].patchValue("10");
              }

              this.registerForm.controls['Color'].patchValue(chipInfo.PetColor);
              if (chipInfo.IdentificationMark)
                this.registerForm.controls['IdentificationMark'].patchValue(chipInfo.IdentificationMark);
              else
                this.registerForm.controls['IdentificationMark'].patchValue(chipInfo.DistinguishMark);

              this.registerForm.controls['DateOfBirth'].patchValue(dob);
              let formattedCurrentDate = currentDate.toISOString().slice(0, 16);
              this.registerForm.controls['LostFoundDate'].patchValue(formattedCurrentDate);

              genderValue = 0;
              if (chipInfo.PetSex) {
                if (chipInfo.PetSex.toLowerCase() == "male" || chipInfo.PetSex.toLowerCase().includes("hanndyr")) {
                  genderValue = 1;
                } else if (chipInfo.PetSex.toLowerCase() == "female" || chipInfo.PetSex.toLowerCase().includes("hunndyr")) {
                  genderValue = 2;
                }
              }
              this.registerForm.controls['Gender'].patchValue(genderValue);
              hairtypeValue = 0;
              if (chipInfo.HairType) {
                if (chipInfo.HairType.toLowerCase() == 'longhair') {
                  hairtypeValue = 1;
                }
                else if (chipInfo.HairType.toLowerCase() == 'sorthair') {
                  hairtypeValue = 2;
                }
              }

              this.registerForm.controls['HairType'].patchValue(hairtypeValue);
              if (chipInfo.SpeciesID == 1 || chipInfo.SpeciesID == 2) {
                this.pets.getBreeds(chipInfo.SpeciesID).subscribe(breeds => {
                  this.MasterBreeds = breeds;
                  this.registerForm.controls['MasterBreedID'].patchValue(chipInfo.BreedID);
                  this.getSuggestion();
                });
              } else {
                this.registerForm.controls['MasterBreedID'].patchValue("");
                this.MasterBreeds = null;
              }

            }
            else {
              // this.chipFound = "No data found for this chipId. Please fill details below."
              this.chipFound = "Ingen data funnet for denne brikken. Vennligst fyll detaljene nedenfor";
            }
          }
          else {
            var chipID = this.registerForm.value.ChipID;
            this.registerForm.controls['ChipID'].patchValue("");
            this.chipFound = "Kjæledyr med ChipId :" + chipID + " er død, og du kan ikke rapportere dette kjæledyret";
          }
        });
      }
    });
  }


  getBreeds() {
    this.registerForm.controls['MasterBreedID'].patchValue("");
    var speciesValue: any;;
    speciesValue = this.registerForm.value.MasterSpeciesID;
    if (speciesValue === "10") {
      this.registerForm.controls['MasterBreedID'].patchValue("");
      this.MasterBreeds = null;
    } else {
      this.pets.getBreeds(speciesValue).subscribe(breeds => {
        this.MasterBreeds = breeds;
        this.getSuggestion();
      });
    }
  }

  @Output() onPosted = new EventEmitter();

  onSubmit() {
    this.submitted = true;
    if (this.imageError) {
      this.scrollToError();
      return;
    }

    if (this.registerForm.value.Image == '' && this.registerForm.value.IsChipped == '0') {
      this.imageError = 'Pet Image is required';
      const ele = document.getElementById('error-msg');
      this.scrollTo(ele);
      return;
    }
    if (this.registerForm.value.Image == '' && this.registerForm.value.IsChipped == '1' && this.previewUrl == 'assets/img/add-plus-icn.svg') {
      this.imageError = 'Pet Image is required';
      const ele = document.getElementById('error-msg');
      this.scrollTo(ele);
      return;
    }
    debugger;
    if (this.registerForm.value.Age != null && this.registerForm.value.Age != '' && !(this.registerForm.value.Age.toString() === parseInt(this.registerForm.value.Age, 10).toString())) {
      this.ageError = 'The age must be entered as a whole number';
      const ele = document.getElementById('Ageerror-msg');
      this.scrollTo(ele);
      return;
    }else{
      this.ageError = '';
    }
    if (this.registerForm.invalid) {
      this.scrollToError();
      return;
    }

    if (this.petImgUrl && !this.fileData) {
      this.registerForm.controls['ImagePath'].patchValue(this.petImgUrl);
    } else {
      this.registerForm.controls['ImagePath'].patchValue(this.fileData);
    }
    this.registerForm.controls['Company'].patchValue(this.currentUser.Company);
    this.registerForm.controls['croppedFileData'].patchValue(this.croppedFileData);
    this.registerForm.controls['lat'].patchValue(this.lat);
    this.registerForm.controls['lng'].patchValue(this.lng);
    this.registerForm.controls['FacebookUserId'].patchValue(this.FBUserid);
    this.registerForm.controls['ShortLivedToken'].patchValue(this.shortToken);
    if (this.minsidePetInfo) {
      this.onPosted.emit(this.registerForm.getRawValue())
      // const firstElementWithError = document.querySelector('.xng-breadcrumb-root');
      // this.scrollTo(firstElementWithError);
    } else {
      this.onPosted.emit(this.registerForm.value)
    }
    const ele = document.getElementById('scrollId');
    this.scrollTo(ele);
    setTimeout(() => {
      $("#switchbar").click();
      $("#exampleCheck2").click();
    }, 500);
  }

  private setCurrentLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 15;
        this.getAddress(this.lat, this.lng);
      });
    }
  }

  toggleFoundSuggestion() {
    this.showFoundSuggestion = !this.showFoundSuggestion;
  }

  markerDragEnd($event: any) {
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
    this.getAddress(this.lat, this.lng);
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.fillAddress(results[0])
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }

  fillAddress(mapresult) {
    this.zoom = 15;
    let area = mapresult.formatted_address;
    //this.registerForm.controls['Area'].patchValue(results[0].formatted_address)
    let place = mapresult;
    this.registerForm.controls['State'].patchValue('');
    this.registerForm.controls['District'].patchValue('');
    this.registerForm.controls['City'].patchValue('');
    this.registerForm.controls['ZipCode'].patchValue('');

    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        var val = place.address_components[i][this.componentForm[addressType]];

        if (addressType == "administrative_area_level_1") {
          this.registerForm.controls['State'].patchValue(val)
        }

        if (addressType == "administrative_area_level_2") {
          this.registerForm.controls['District'].patchValue(val)
        }

        if (addressType == "country") {
          area = area.replace(val, "")
        }

        if (addressType == "locality") {
          this.registerForm.controls['City'].patchValue(val)
        }

        if (addressType == "postal_town") {
          this.registerForm.controls['City'].patchValue(val)
        }

        if (addressType == "postal_code") {
          this.registerForm.controls['ZipCode'].patchValue(val)
        }
      }
    }

    area = area.trim();
    //let comma = area.substring(area.length, area.length - 1)
    let commaIndex = area.indexOf(",");
    if (commaIndex > 0) {
      //area = area.substring(0, area.length - 1)
      area = area.substring(0, commaIndex);
    }
    area = area.trim();
    this.registerForm.controls['Area'].patchValue(area)
  }

  async fileProgress(fileInput: any) {    
    this.imageError = null;
    this.imageChangedEvent = event;
    let isPetsafeSearch;
    if (<File>fileInput.target.files && <File>fileInput.target.files[0]) {
      var image = await this.toBase64(fileInput.target.files[0]);
      if(image != null && image != undefined){
        this.SpinnerService.show();  
        var isPet = await this.getgooglevisionapi(image.toString().split(',')[1]);  
        if(isPet)
        {
        isPetsafeSearch = await this.getgooglevisionapiSafeSearch(image.toString().split(',')[1]); 
        this.SpinnerService.hide(); 
          if(!isPetsafeSearch){
            this.translate.get('This image contains Explicit Content. Try another image.').subscribe((data:any)=> {
              this.imageError = data;
             });
             this.SpinnerService.hide();    
            return false;
          } 
        } 
        else
        {
          this.translate.get('Pet is not visible in this picture. Please try different image.').subscribe((data:any)=> {
            this.imageError = data;
           });
           this.SpinnerService.hide();    
          return false;
        }   
        this.SpinnerService.hide();    
      }      
      // Size Filter Bytes
      const max_size = 15000000;
      const allowed_types = ['image/png', 'image/jpeg'];
      const max_height = 15200;
      const max_width = 25600;

      if (fileInput.target.files[0].size > max_size) {
        this.imageError =
          'Maximum size allowed is ' + max_size / 1000 + 'kb';

        return false;
      }
      if (!allowed_types.includes(fileInput.target.files[0].type)) {
        this.imageError = 'Only Images are allowed ( JPG | PNG )';
        return false;
      }
      
      let Content: HTMLElement = document.getElementById("contentNew") as HTMLElement
      Content.click();
      
      this.fileData = <File>fileInput.target.files[0];
      // this.preview();
  }
}

  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    }
  }
  public noWhitespaceValidator(control: FormControl) {
    if (control.value && control.value.length > 0) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    }
  }

  public onIsChippedChange() {
    this.registerForm.controls["ChipID"].clearValidators();
    if (this.registerForm.controls.IsChipped.value == 1) {
      this.registerForm.controls["ChipID"].setValidators([Validators.required, this.noWhitespaceValidator]);
      this.registerForm.controls["IsChipIDinDetail"].patchValue(0);
    }
    this.registerForm.controls["ChipID"].updateValueAndValidity()
  }

  public onChipChage(event: any) {
    this.isChipSelected = event.target.value;
    this.registerForm.controls["ChipID"].clearValidators();
    if (this.registerForm.controls.IsChipped.value == 1) {
      this.registerForm.controls["ChipID"].setValidators([Validators.required, this.noWhitespaceValidator]);
      this.registerForm.controls["IsChipIDinDetail"].patchValue(0);
    }
    this.registerForm.controls["ChipID"].updateValueAndValidity();
  }

  public onClickFillDate() {
    this.registerForm.controls['LostFoundDate'].patchValue(new Date())
  }

  public onClickFillAddress() {
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: []
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.fillAddress(place)
          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 15;
          this.getSuggestion();
        });
      });
    });
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    this.scrollTo(firstElementWithError);
  }

  toggleShowChipNumber = () => {
    this.isChipIdToShowInDetail = !this.isChipIdToShowInDetail;
    this.registerForm.controls['IsChipIDinDetail'].patchValue(this.isChipIdToShowInDetail);
  }

  getZipCodeCity(zipCode: any) {
    zipCode = zipCode.replace(/\s/g, "");
    if (zipCode != '' && zipCode.length > 3) {
      this.pets.getZipCodeCity(zipCode).subscribe(response => {
        if (response.StatusCode == 200) {
          let city = response?.Data?.City
          this.registerForm.controls['City'].patchValue(city);
        }
      });
    }
  }

  ngAfterViewInit(): void {    
    this.imgctrl.nativeElement.focus();
    this.imgctrl.nativeElement.setAttribute('tabindex', "0");
    const ele = document.getElementById('scrollId');
    this.scrollTo(ele);
  }
  toBase64 = file => new Promise((resolve, reject) => {    
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  getgooglevisionapi = imageBase64 => new Promise((resolve, reject) => {    
    this.pets.googlevision(imageBase64,"OBJECT_LOCALIZATION").subscribe((response) => {
      if (response) {
        var isPet = false;
        const ObjectAnnotations = response['responses'][0]['localizedObjectAnnotations'];
        if (ObjectAnnotations === undefined || ObjectAnnotations === null) {                    
          resolve(isPet);
      } else {
        var PetCnt = 0;
        ObjectAnnotations.forEach(Object1 =>{
          console.log(Object1.name);         
          if(this.Animals.includes(Object1.name) ){
            PetCnt++;
          }          
        });   
        console.log(PetCnt);
          if(PetCnt > 0){            
            isPet = true;
          }     
      }        
      } else {
        isPet = true;
      }
      resolve(isPet);
    });
  });
  getgooglevisionapiSafeSearch = imageBase64 => new Promise((resolve, reject) => {    
    this.pets.googlevision(imageBase64,"SAFE_SEARCH_DETECTION").subscribe((response) => {
      if (response) {
        var isPet = false;
        const ObjectsafeSearchAnnotation = response['responses'][0]['safeSearchAnnotation'];
        if (ObjectsafeSearchAnnotation === undefined || ObjectsafeSearchAnnotation === null) {  
          isPet = true;                  
          resolve(isPet);
      } else {
        isPet = true;
          if(ObjectsafeSearchAnnotation.adult == "LIKELY" || ObjectsafeSearchAnnotation.violence == "LIKELY" ||ObjectsafeSearchAnnotation.racy == "LIKELY"||
          ObjectsafeSearchAnnotation.adult == "VERY_LIKELY" || ObjectsafeSearchAnnotation.violence == "VERY_LIKELY" ||ObjectsafeSearchAnnotation.racy == "VERY_LIKELY"){
            isPet = false;
          }                                              
      }        
      } else {
        isPet = true;
      }
      resolve(isPet);
    });
  });
  public ShareONFacebookClick() {
   // if (!this.registerForm.value.ShareONFacebook || this.registerForm.value.ShareONFacebook == "") {
      debugger;
      //if (confirm("Lag Facebook-innlegg?")) {
        let socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
        this.authService.signIn(socialPlatformProvider).then(
          (userData) => {
            debugger;              
            this.registerForm.value.FacebookUserId = userData.id;
            this.registerForm.value.ShortLivedToken = userData.authToken;   
            this.FBUserid = userData.id;
            this.shortToken = userData.authToken;       
          }
        );
      // } else {
      //   this.registerForm.value.ShareONFacebook = false;
      // }
    //}
  }
}





